import { useQuery } from "@tanstack/react-query";

import axios from "../../../../../../utils/axiosInceptor";
import { dashboardApiV1Endpoint } from "../../../../../../api/v1/endpoints";

const getAcceptedRenewal = async (body) => {
  const url = `${dashboardApiV1Endpoint}/dashboard/accepted-renewals`;
  const response = await axios.post(url, body);
  return response?.data?.result;
};

export const useGetRenewalAccept = (filterData) => {
  const { data, isLoading } = useQuery({
    queryKey: ["accepted-renewal", filterData?.queryParams],
    queryFn: () => getAcceptedRenewal(filterData?.queryParams),
    staleTime: 1000 * 60 * 5, // ✅ 5 minutes
    refetchOnWindowFocus: false, // 👈 disable auto refetch when window regains focus
  });

  return {
    renewalAccepted: data ?? [],
    isLoading: isLoading,
  };
};
